export const FETCH_RISK_SCORE_CHARGES_REQUEST = "FETCH_RISK_SCORE_CHARGES_REQUEST";
export const FETCH_RISK_SCORE_CHARGES_SUCCESS = "FETCH_RISK_SCORE_CHARGES_SUCCESS";
export const FETCH_RISK_SCORE_CHARGES_FAILURE = "FETCH_RISK_SCORE_CHARGES_FAILURE";
export const FETCH_RISK_SCORE_CHARGES_RESET = "FETCH_RISK_SCORE_CHARGES_RESET";
export const fetchRiskScoreChargesRequest = (payload) => ({
    type: FETCH_RISK_SCORE_CHARGES_REQUEST,
    payload,
});
export const fetchRiskScoreChargesSuccess = (payload) => ({
    type: FETCH_RISK_SCORE_CHARGES_SUCCESS,
    payload,
});
export const fetchRiskScoreChargesFailure = (payload) => ({
    type: FETCH_RISK_SCORE_CHARGES_FAILURE,
    payload,
});
export const fetchRiskScoreChargesReset = () => ({
    type: FETCH_RISK_SCORE_CHARGES_RESET,
});
